<template>
  <div>
    <v-list-item
      link
      @click="handleLaunchText()"
      :disabled="isLocked"
      class="my-n2">
      <v-list-item-avatar class="mr-0">
        <v-icon
          v-if="isLocked"
          class="grey--text">mdi-lock</v-icon>
        <v-icon
          v-else-if="isCompleted"
          class="success--text">mdi-check-circle</v-icon>
        <v-icon
          v-else
          :class="{ 'grey--text': !isActive }"
          :style="isActive ? activeStyle : inactiveStyle">mdi-card-text-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-subtitle>{{ textElement.text.title }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';

export default {
  name: 'TextTOC',
  props: {
    textElement: Object,
  },
  data: () => ({
    inactiveStyle: {
      color: 'gray',
    },
    shownNextItemToast: false,
  }),
  computed: {
    ...mapState([
      'activeModuleItemId',
      'activeTextElement',
      'allModuleItemAttempts',
      'courseHash',
      'nextItem',
      'playlist',
      'requiredItemIndex',
      'snackbar',
      'user',
    ]),
    activeStyle() {
      return { color: this.playlist.default_color };
    },
    isActive() {
      return this.activeModuleItemId === this.textElement.itemId;
    },
    isCompleted() {
      return !!_.get(this.moduleItemAttempt, 'complete', false);
    },
    isLocked() {
      if (
        _.get(this.playlist, 'config.lockProgression')
        && this.textIndex > this.requiredItemIndex
        && (this.textElement.itemId !== this.nextItem.itemId)
        && this.user.userType !== 'teacher') {
        return true;
      }
      return false;
    },
    moduleItemAttempt() {
      return _.find(this.allModuleItemAttempts, { moduleItemId: this.textElement.id });
    },
    textIndex() {
      return _.findIndex(this.playlist.allModuleItems, { itemId: this.textElement.itemId });
    },
  },
  methods: {
    ...mapActions([
      'markModuleItemAttemptComplete',
      'setModuleItem',
    ]),
    ...mapMutations([
      'forceCloseSnackbar',
      'setActiveModuleItemId',
      'setActiveTextElement',
      'setNextItemTimeoutToast',
      'toggleSnackbar',
    ]),
    handleLaunchText() {
      this.setModuleItem(this.textElement);
      this.setActiveTextElement(this.textElement.text);
      const path = `/course/${this.courseHash}/module/${this.textElement.moduleId}/item/${this.textElement.itemId}`;
      if (this.$route.path !== path) {
        this.$router.push({
          name: 'Course Home',
          params: { courseHash: this.courseHash, moduleId: this.textElement.moduleId, itemId: this.textElement.itemId },
        });
      }
      if (
        _.get(this.snackbar, 'open')
        && (
          this.textElement.itemId !== this.activeModuleItemId
          && _.get(this.playlist, 'config.lockProgression')
        )
      ) this.forceCloseSnackbar();
    },
    popNextItemToast(timeout = 5000) {
      if (_.get(this.user, 'userType', '') === 'teacher') return;
      const toastTimeout = setTimeout(() => {
        this.shownNextItemToast = true;
        const lastModuleItemIndex = this.playlist.allModuleItems.length - 1;
        const currentModuleItemIndex = _.findIndex(this.playlist.allModuleItems, { itemId: this.activeModuleItemId });
        if (currentModuleItemIndex === lastModuleItemIndex) {
          this.snackbarAction = false;
        } else {
          this.snackbarAction = true;
        }
        this.markModuleItemAttemptComplete(this.textElement.id);
        this.toggleSnackbar({
          text: 'Item completed!',
          color: 'success',
          action: this.snackbarAction,
          timeout: this.snackbarAction ? -1 : 5000,
        });
      }, timeout);
      this.setNextItemTimeoutToast(toastTimeout);
    },
  },
  created() {
    if (
      this.isActive
      && !this.shownNextItemToast
      && this.user.userType !== 'teacher'
    ) this.popNextItemToast();
  },
  watch: {
    isActive(n, o) {
      if (
        n
        && !o
        && !this.shownNextItemToast
      ) this.popNextItemToast();
      // Text is complete and user didn't click Next Item toast in lockedProgression playlist - re-pop toast
      if (
        n
        && this.isCompleted
        && this.requiredItemIndex === this.textIndex
        && _.get(this.playlist, 'config.lockProgression')
      ) this.popNextItemToast(0);
    },
  },
};
</script>

<style lang="scss">
  .v-list-item__subtitle {
    /* Overrides Vuetify styling on li elements to wrap longer bulb names */
    overflow: visible !important;
    white-space: normal !important;
  }
</style>
